import React from 'react'
import { ActionIcon, DisabledActionIcon } from './style'
import Tippy from '@tippyjs/react'

export interface ApproveRejectButtonsProps {
  positiveAction: Function
  negativeAction: Function
  disabled?: boolean
  tipyContent?: string
}

export const ApproveRejectButtons = ({ positiveAction, negativeAction, disabled = false, tipyContent }: ApproveRejectButtonsProps): JSX.Element => {
  if (disabled) {
    return (
      <Tippy
        content={tipyContent}
        animation="scale"
      >
        <div className='d-flex flex-nowrap gap-2'>
          <button
            disabled
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '4px',
              border: 'none',
              backgroundColor: '#e9ecef',
              cursor: 'not-allowed',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <DisabledActionIcon
              icon={['fas', 'check']}
              color="var(--grey)"
            />
          </button>
          <button
            disabled
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '4px',
              border: 'none',
              backgroundColor: '#e9ecef',
              cursor: 'not-allowed',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <DisabledActionIcon
              icon={['fas', 'xmark']}
              color="var(--grey)"
            />
          </button>
        </div>
      </Tippy>
    )
  }

  return (
    <div className='d-flex flex-nowrap gap-2'>
      <button
        onClick={() => positiveAction()}
        style={{
          width: '32px',
          height: '32px',
          borderRadius: '4px',
          border: 'none',
          backgroundColor: '#28a745',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'opacity 0.2s'
        }}
        onMouseOver={(e) => e.currentTarget.style.opacity = '0.8'}
        onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
      >
        <ActionIcon
          icon={['fas', 'check']}
          color="white"
        />
      </button>
      <button
        onClick={() => negativeAction()}
        style={{
          width: '32px',
          height: '32px',
          borderRadius: '4px',
          border: 'none',
          backgroundColor: '#dc3545',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'opacity 0.2s'
        }}
        onMouseOver={(e) => e.currentTarget.style.opacity = '0.8'}
        onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
      >
        <ActionIcon
          icon={['fas', 'xmark']}
          color="white"
        />
      </button>
    </div>
  )
}
